<template>
  <b-card no-body>
    <b-card-header>
      <b-card-title>Total sell to buy ratio</b-card-title>
    </b-card-header>
    <b-card-body class="d-flex justify-content-center align-items-center">
      <div v-if="loading">
        <div class="d-flex align-items-center justify-content-center">
          <b-skeleton
            class="rounded-circle mr-0"
            width="150px"
            height="140px"
          ></b-skeleton>
        </div>
        <div class="d-flex align-items-center justify-content-center mt-1">
          <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
          <b-skeleton width="40px" height="15px" class="mx-50"></b-skeleton>
        </div>
      </div>
      <div
        v-else-if="
          analytics &&
          analytics.sell_to_buy_ratio &&
          (analytics.sell_to_buy_ratio.buy || analytics.sell_to_buy_ratio.sell)
        "
      >
        <doughnut-chart
          :chartData="chartData"
          :colors="['#39A4F8', '#FBAD25']"
          :labels="['Buy', 'Sell']"
          height="120px"
          width="120px"
        />
      </div>
      <template v-else>
        <div class="d-flex justify-content-center h-100 new-alert">
          <div
            class="mt-2"
            style="
              border-radius: 100px;
              height: 115px;
              width: 115px;
              border: 23px solid rgb(45 45 53 / 44%);
            "
          ></div>
        </div>
      </template>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardTitle,
  BCardBody,
  BSkeleton,
  BAlert,
} from "bootstrap-vue";
import DoughnutChart from "@/views/components/doughnut-chart/DoughnutChart.vue";
export default {
  components: {
    DoughnutChart,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardBody,
    BSkeleton,
    BAlert,
  },
  props: {
    analytics: {
      type: Object,
      default: () => {},
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    chartData() {
      return [
        this.analytics.sell_to_buy_ratio.buy,
        this.analytics.sell_to_buy_ratio.sell,
      ];
    },
  },
};
</script>

<style></style>
